"use client"

import { ServicePillar, LocationId, LOCATIONS, SERVICE_PILLARS } from "@/data/booking-appointments"
import { ArrowLeft } from "lucide-react"

interface PillarStepProps {
  location: LocationId
  onSelect: (pillar: ServicePillar) => void
  onBack: () => void
}

/**
 * PillarStep - Select service pillar (step 2)
 *
 * User selects their service category after choosing location.
 * Phase 1: Only "General Health" is available.
 * Phase 2+: Will include Fertility, Pregnancy, etc.
 */
export function PillarStep({ location, onSelect, onBack }: PillarStepProps) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={onBack}
          className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-3 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>
        <div className="text-center">
          <h2 className="text-xl font-normal text-[#3f4141] mb-2 mt-6">
            What brings you in today?
          </h2>
          <p className="text-sm font-light text-[#3f4141] mt-1">
            {LOCATIONS[location]}
          </p>
        </div>
      </div>

      {/* Pillar Options */}
      <div className="space-y-4">
        {SERVICE_PILLARS.map((pillar) => (
          <button
            key={pillar.id}
            onClick={() => onSelect(pillar)}
            className="w-full p-4 text-left bg-gray-100 border border-gray-200 rounded-xl hover:border-[#848974] hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="text-base font-normal text-[#3f4141]">{pillar.name}</span>
              <span className="text-[#848974] font-medium text-sm">Select</span>
            </div>
          </button>
        ))}
      </div>

      {/* Help text for Phase 1 */}
      {SERVICE_PILLARS.length === 1 && (
        <p className="text-sm font-light text-gray-500 text-center">
          More service categories coming soon.
        </p>
      )}
    </div>
  )
}
